import React, { useContext } from 'react';
import { omit } from '../../utils/index.js';
import { FieldElement, SelectElement } from './select.styles.js';
import { SelectContext } from './use-select-state.js';
export const SelectFieldComponent = ({ children }) => {
    const { props, state } = useContext(SelectContext).selectState;
    const { containerRef, label, loading, hiddenLabel, errorMessage, description, dataAutomation, className, fullWidth, isRequired, } = props;
    const { fieldAria } = state;
    const labelProp = {
        ...omit(fieldAria.labelProps, 'aria-labelledby'),
        children: label,
        hiddenLabel,
    };
    const errorProp = {
        ...fieldAria.errorMessageProps,
        message: errorMessage,
    };
    const descriptionProp = {
        ...fieldAria.descriptionProps,
        message: typeof description === 'function'
            ? description()
            : description,
    };
    return (React.createElement(FieldElement, { containerRef: containerRef, loading: loading === 'control-skeleton', label: labelProp, error: errorProp, description: descriptionProp, dataAutomation: dataAutomation, className: className, fullWidth: fullWidth, isRequired: isRequired },
        React.createElement(SelectElement, { fullWidth: fullWidth }, children)));
};
//# sourceMappingURL=select-field.component.js.map